/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.DocsAndForms {

    declare var screenfull: any;

    class KioskModeExitModalController {

        static $inject = [
            '$mdDialog',
            '$http',
            '$translate',
            '$rootScope',
            'meevo.AppSettings',
            'meevo.components.common.KioskModeLogic',
            '$cookies'
        ];

        public loginStatus: string;
        public userName: string;
        public password: string;

        public model: any;
        public userForm: any;

        public oneTry: boolean;
        public headerText: string;

        constructor(
            protected $mdDialog: ng.material.IDialogService,
            protected $http: angular.IHttpService,
            protected $translate: angular.translate.ITranslateService,
            protected $rootScope: angular.IRootScopeService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected kioskModelLogic: Meevo.Components.Common.KioskModeLogic,
            protected $cookies: angular.cookies.ICookiesService) {
        }

        public exit(): void {
            this.loginStatus = '';

            this.kioskModelLogic.checkCredentials(this.userName, this.password)
                .then((userExists: boolean) => {
                    if (userExists) {
                        this.kioskModelLogic.disableLogOutOnReload(this.$rootScope);

                        if (this.kioskModelLogic.isSameUser(this.userName)) {
                            this.exitFullScreen();
                            this.$mdDialog.hide();
                        } else {
                            this.kioskModelLogic
                                .loginNewUser(this.userName, this.password)
                                .then(() => {
                                    window.location.reload();
                                });
                        }
                    } else {
                        this.authorizeFailed();
                    }
                })
                .catch((error) => {
                    // Spike 107050: Handle expired session during kiosk mode (device sleep/timeout)
                    // If session expired (401), do full login instead of letting interceptor redirect to login page
                    if (error.status === 401) {
                        this.kioskModelLogic.disableLogOutOnReload(this.$rootScope);
                        this.kioskModelLogic
                            .loginNewUser(this.userName, this.password)
                            .then(() => {
                                window.location.reload();
                            })
                            .catch(() => {
                                this.authorizeFailed();
                            });
                    } else {
                        this.authorizeFailed();
                    }
                });
        }

        public cancelModal(): void {
            this.$mdDialog.cancel();
        }

        private authorizeFailed() {
            if (this.oneTry) {
                this.cancelModal();
            } else {
                this.loginStatus = this.$translate.instant('LABEL_INVALID_AUTHENTICATION');
            }
        }

        private exitFullScreen() {
            if (screenfull.enabled && !navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
                screenfull.exit();
            }
        }
    }

    angular.module('meevo')
        .controller('meevo.components.kioskModeExitModal.KioskModeExitModalController', KioskModeExitModalController);
}
